export default __webpack_public_path__ + "static/media/copyLink.6201d0e6.svg";